<div class="drafts-container">
  <app-search-guides #searchGuides
                     class="block mt-48px"
                     [associatedInsiderId]="associatedInsiderId"
                     [status]="types.GuideStatus.Draft"></app-search-guides>
</div>
